<div class="flex pl-2 pr-6 gap-2 justify-start items-center 2xl:text-lg">
	<i-tabler
		class="w-4 h-4 min-h-4 min-w-4 text-orange-500"
		name="alert-triangle"
	/>
	<span class="text-gray-500">Missing Info</span>
	<ui-anchor [href]="href" [testHook]="testHooks.Anchor">Verify</ui-anchor>
</div>
